var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "appointment-calendar" },
    [
      _c("v-date-picker", {
        attrs: {
          "available-dates": _vm.availableDates.length
            ? _vm.availableDates
            : null,
          "disabled-dates": _vm.availableDates.length
            ? null
            : { weekdays: [1, 2, 3, 4, 5, 6, 7] },
        },
        on: { input: _vm.handleOnInput },
        model: {
          value: _vm.selectedDate,
          callback: function ($$v) {
            _vm.selectedDate = $$v
          },
          expression: "selectedDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }